import { render, staticRenderFns } from "./coursePull.vue?vue&type=template&id=6a196b24&scoped=true&"
import script from "./coursePull.vue?vue&type=script&lang=js&"
export * from "./coursePull.vue?vue&type=script&lang=js&"
import style0 from "./coursePull.vue?vue&type=style&index=0&id=6a196b24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a196b24",
  null
  
)

export default component.exports